module.exports = __webpack_public_path__ + "static/media/icon-messages.e76f31f6.svg";